function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M437 75c100 100 100 262 0 362s-262 100-362 0-100-262 0-362 262-100 362 0zM256 204l-43-43c-14-14-38-14-52 0-14 15-14 38 0 52l43 43-43 43c-14 14-14 38 0 52 15 14 38 14 52 0l43-43 43 43c14 14 38 14 52 0 14-15 14-38 0-52l-43-43 43-43c14-14 14-38 0-52-15-14-38-14-52 0z"
}));